import { Crunchbase, Global, Linkedin, Twitter, View } from '@clearkit/icons';
import { CKLayoutHorizontalProps } from 'clearkit';
import { Link } from 'react-router-dom';

import { routes } from '~/components/app/appMainRoutes';
import {
  TokenButton,
  TokenGroup,
  TokenLink,
} from '~/components/ListItem/Tokens';
import { trackEvent } from '~/lib/tracking';

import { TargetMarketsCompany } from '../types';

type CompanyLinksProps = CKLayoutHorizontalProps & {
  company: TargetMarketsCompany;
};

export const CompanyLinks = ({
  children,
  company,
  ...rest
}: CompanyLinksProps) => {
  const { domain, linkedin, twitter, crunchbase } = company;

  const handleItemClick = () => {
    trackEvent('target_market_company_clicked', { domain });
  };

  return (
    <TokenGroup {...rest}>
      <TokenLink
        hasToken={!!linkedin}
        href={`https://linkedin.com/${linkedin}`}
        target="_blank"
      >
        <Linkedin />
      </TokenLink>
      <TokenLink
        hasToken={!!twitter}
        href={`https://twitter.com/${twitter}`}
        target="_blank"
      >
        <Twitter />
      </TokenLink>
      <TokenLink
        hasToken={!!crunchbase}
        href={`https://crunchbase.com/${crunchbase}`}
        target="_blank"
      >
        <Crunchbase />
      </TokenLink>
      <TokenLink hasToken={!!domain} href={`https://${domain}`} target="_blank">
        <Global />
      </TokenLink>
      <TokenButton
        aria-label="View company"
        as={Link}
        hasToken
        onClick={handleItemClick}
        to={`${routes.targetMarkets}/${domain}`}
      >
        <View />
      </TokenButton>
      {children}
    </TokenGroup>
  );
};
